var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAboutStroke5 = function SvgAboutStroke5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#205287",
    strokeDasharray: "22 22",
    strokeLinecap: "round",
    strokeWidth: 3,
    d: "M260.515 16.297c-42.245-5.924-84.65-14.884-127.009-14.482-11.83.113-23.899-1.22-35.68 1.248-7.858 1.646-15.6 4.339-23.49 5.59-24.007 3.81-47.845 11.212-71.926 13.4"
  })));
};
export default SvgAboutStroke5;